/**
 * META2-04 (PR #352): AI Consent API Client
 *
 * Frontend client para los endpoints de consentimiento Ley 172-13 RD.
 * Backend: apps/api/src/core/llm-proxy/controllers/ai-consent.controller.ts
 */
import { privateApi } from '@/config/axios.config';

export interface AiConsent {
  id: string;
  userId: string;
  tenantId: string;
  consentVersion: string;
  acceptedAt: string;
  acceptedIpAddress: string | null;
  acceptedUserAgent: string | null;
  dataCategories: string[];
  providers: string[];
  revokedAt: string | null;
  revokedReason: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GrantConsentPayload {
  consentVersion: string;
  dataCategories?: string[];
  providers?: string[];
}

const API = '/ai/consent';

export const aiConsentApi = {
  /**
   * Get active consent for the authenticated user.
   * Returns null if no consent granted yet (or all revoked).
   */
  async getActive(): Promise<AiConsent | null> {
    const response = await privateApi.get<{
      success: boolean;
      data: AiConsent | null;
    }>(API);
    return response.data.data;
  },

  /**
   * Grant consent — Ley 172-13 RD Art. 5.4 explicit consent.
   * Idempotent: re-granting actualiza versión + acceptedAt.
   */
  async grant(payload: GrantConsentPayload): Promise<AiConsent> {
    const response = await privateApi.post<{ success: boolean; data: AiConsent }>(
      API,
      payload,
    );
    return response.data.data;
  },

  /**
   * Revoke active consent — Ley 172-13 RD (consent, Art. 5.4) revocability.
   */
  async revoke(reason?: string): Promise<AiConsent | null> {
    const response = await privateApi.delete<{
      success: boolean;
      data: AiConsent | null;
      message: string;
    }>(API, { data: { reason } });
    return response.data.data;
  },
};
